<template>
  <layout-main-inner :title="`${envName}详情`">
    <el-button
      slot="action"
      type="primary"
      :loading="loading"
      @click="updatetracingenvinfo">编辑</el-button>
    <el-form
      :model="traceinfo"
      disabled=""
      label-position="top">
      <layout-card-wrap
        v-loading="loading"
        hasHeaderSlot>
        <template slot="title">基本信息</template>
        <el-row
          :gutter="20"
          type="flex">
          <el-col :span="8">
            <el-form-item :label="envName + '名称:'">
              {{ traceinfo.envInfoName }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="envName + '图片:'">
              <upload-image
                v-model="traceinfo.envImage"
                status="detail" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="20"
          type="flex">
          <template v-for="(item, index) in traceinfo.extraFields">
            <el-col
              :key="item.name"
              :span="item.type==='IMAGE' ? 24 : 8">
              <smart-form
                :item="item"
                status="detail"
                :vendorId="traceinfo.vendorId"
                :prop="'extraFields.' + index + '.fieldValue'" />
            </el-col>
          </template>
        </el-row>
      </layout-card-wrap>
    </el-form>
    <template slot="footer">
      <!-- <back-button /> -->
      <!-- <el-button
        type="primary"
        :loading="loading"
        @click="updatetracingenvinfo">编辑</el-button> -->
    </template>
    <trace-info-modal
      ref="modal"
      action="update"
      :current="current"
      :envInfoType="envInfoType"
      :envName="envName"
      :fetch="gettracingenvinfo" />
  </layout-main-inner>
</template>

<script>
import TraceInfoModal from './trace-info-modal.vue'
import UploadImage from '@/components/public/upload-image-new.vue'
import clonedeep from 'lodash.clonedeep'
import '@/components/business/custom-form/index'
export default {
  name: 'TraceinfoDetail',
  components: { TraceInfoModal, UploadImage },
  props: {
    envInfoType: {
      type: Number,
      default: 1
    },
    envName: String
  },
  data() {
    return {
      loading: false,
      traceinfo: {},
      current: {}
    }
  },
  mounted() {
    this.gettracingenvinfo()
  },
  methods: {
    gettracingenvinfo() {
      this.loading = true
      this.$store.dispatch('traceinfo/gettracingenvinfo', {
        payload: {
          vendorId: this.$route.query.vendorId,
          envInfoId: this.$route.query.envInfoId
        },
        success: (res) => {
          this.loading = false
          res.data.envImage = res.data.envImage.split(',').map(item => {
            return {
              url: item,
              name: '' + item.split('/').slice(-1)
            }
          })
          this.traceinfo = res.data
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    updatetracingenvinfo() {
      this.current = clonedeep(this.traceinfo)
      this.$refs.modal.toggleModal(true)
    }
  }
}
</script>
